export default __webpack_public_path__ + "static/media/layer1.ab766f93.svg";